<div
  id="centre-beacon"
  tabindex="0"
  [style.background-color]="rgbColor"
  style="
    position: fixed;
    border: medium none;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: rgba(0, 0, 0, 0.25) -4px 0px 4px;
    border-radius: 7px 0px 0px 7px;
    background: none repeat scroll 0% 0%;
    font-family: Lato;
    opacity: 1;
    z-index: 999999998;
  "
  class="rotated"
>
  <div id="beacon-container">
    <div id="beacon-icon"></div>
    <div id="beacon-text" style="color: rgb(255, 255, 255); display: block">
      <a (click)="onclick()">{{ text }}</a>
    </div>
  </div>
</div>
